/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestBoxInfo
 */
export interface RequestBoxInfo {
    /**
     * 
     * @type {string}
     * @memberof RequestBoxInfo
     */
    contentInformationSource?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestBoxInfo
     */
    height?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestBoxInfo
     */
    length?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestBoxInfo
     */
    quantity?: number;
    /**
     * 
     * @type {string}
     * @memberof RequestBoxInfo
     */
    unitOfMeasurement?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestBoxInfo
     */
    weight?: number;
    /**
     * 
     * @type {string}
     * @memberof RequestBoxInfo
     */
    weightUnit?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestBoxInfo
     */
    width?: number;
}

/**
 * Check if a given object implements the RequestBoxInfo interface.
 */
export function instanceOfRequestBoxInfo(value: object): value is RequestBoxInfo {
    return true;
}

export function RequestBoxInfoFromJSON(json: any): RequestBoxInfo {
    return RequestBoxInfoFromJSONTyped(json, false);
}

export function RequestBoxInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestBoxInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'contentInformationSource': json['content_information_source'] == null ? undefined : json['content_information_source'],
        'height': json['height'] == null ? undefined : json['height'],
        'length': json['length'] == null ? undefined : json['length'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'unitOfMeasurement': json['unit_of_measurement'] == null ? undefined : json['unit_of_measurement'],
        'weight': json['weight'] == null ? undefined : json['weight'],
        'weightUnit': json['weight_unit'] == null ? undefined : json['weight_unit'],
        'width': json['width'] == null ? undefined : json['width'],
    };
}

export function RequestBoxInfoToJSON(json: any): RequestBoxInfo {
    return RequestBoxInfoToJSONTyped(json, false);
}

export function RequestBoxInfoToJSONTyped(value?: RequestBoxInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content_information_source': value['contentInformationSource'],
        'height': value['height'],
        'length': value['length'],
        'quantity': value['quantity'],
        'unit_of_measurement': value['unitOfMeasurement'],
        'weight': value['weight'],
        'weight_unit': value['weightUnit'],
        'width': value['width'],
    };
}

